import React from 'react';

import * as CONFIG from 'constants/config';

const UserItem = ({user, index, currentPage}) => {
  const onClickDelete = (id) => {
    alert('TODO: step 2');
  };

  const num = (index + 1) + ((currentPage - 1) * CONFIG.COUNT_PER_PAGE);

	return (
		<tr>
      <td>{num}</td>
      <td>
        <small>{user.uid}</small>
      </td>
      <td align="center">
        {user.photoURL ? <img src={user.photoURL} alt={user.uid} width="50" /> : null}
      </td>
      <td>
        {user.email}
      </td>
      <td align="center">
        {user.emailProvider}
      </td>
      <td>
        {user.nameFirst} {user.nameLast}
        <br />
        <small>({user.displayName})</small>
      </td>
      <td align="center">
        {user.language}
      </td>
      <td>
        {user.dateCreated}
        <br />
        {user.dateModified} 
      </td>
      <td>
        <p>
          <a className="btn btn-warning btn-xs" href={`/users/${user.uid}`}>
            <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
          </a>
          &nbsp;&nbsp;
          <button className="btn btn-grey btn-xs" onClick={() => onClickDelete(user.uid)}>
            <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
          </button>
        </p>
      </td>
		</tr>
	);
};

export default UserItem;
